import React, { createContext } from 'react';

export type TaskCollapsedContextType = {
  readonly collapsed: boolean;
  handleCollapsed: () => void;
};

// MEMO: 初期値は仮実装で埋める
export const TaskCollapsedContext = createContext<TaskCollapsedContextType>({
  collapsed: false,
  handleCollapsed: () => {},
});

export const useTaskCollapsedContext = (): TaskCollapsedContextType => {
  const [collapsed, setCollapsed] = React.useState<boolean>(false);

  const handleCollapsed = () => {
    setCollapsed((prevState) => !prevState);
  };

  return {
    collapsed,
    handleCollapsed,
  };
};
